import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner'
import InputGroup from 'react-bootstrap/InputGroup'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Alert from 'react-bootstrap/Alert'
import { toast } from 'react-toastify'
import Paginacion from 'components/Paginacion'
import api from 'api/api'

import './regulaciones.css'
import NuevaRegulacion from './NuevaRegulacion'
import { DEFAULT_FETCH_CUANTOS } from 'utils/constants'
import { debounce } from 'utils/debounce'
import VerRegulacion from './VerRegulacion'
import EliminarRegulacion from './EliminarRegulacion'
import EditarRegulacion from './EditarRegulacion'


function Regulaciones(props) {
	const [fetchDeACuantos, setFetchDeACuantos] = useState(DEFAULT_FETCH_CUANTOS)
	const [numResultados, setNumResultados] = useState(0)
	const [paginaAct, setPaginaAct] = useState(1)
	const [loading, setLoading] = useState(false)

	const [busqueda, setBusqueda] = useState('')
	const [filtroBusqueda, setFiltroBusqueda] = useState('')
	const [regulaciones, setRegulaciones] = useState([])
	const [regulacionActual, setRegulacionActual] = useState()
	const [queMostrar, setQueMostrar] = useState('')

	const opcionesCuantosMostrar = [10, 25, 50]

	const refreshRegulaciones = async () => {
		try {
			setLoading(true)
			const { datos } = await api.post('p/ver-regulaciones-sanitarias', {
				cuantos: fetchDeACuantos,
				desde: paginaAct === 1 ? 0 : (paginaAct - 1) * fetchDeACuantos,
				filtros: {
					titulo: [filtroBusqueda],
				}
			})

			setRegulaciones(datos.regulaciones)
			setNumResultados(datos.numResultados)
		} catch (error) {
			toast.error('Error de conexión')
			console.error(error)
		} finally {
			setLoading(false)
		}
	}

	const handleBusqueda = (value) => {
		if (value) {
			setFiltroBusqueda(value)
		} else {
			setFiltroBusqueda('')
		}
	}

	const debouceFiltroBusqueda = React.useCallback(
		debounce(handleBusqueda, 400),
		[]
	)

	useEffect(() => {
		debouceFiltroBusqueda(busqueda)
	}, [busqueda])

	useEffect(() => {
		if (paginaAct === 1) {
			refreshRegulaciones()
		} else {
			setPaginaAct(1)
		}
	}, [filtroBusqueda, fetchDeACuantos])

	useEffect(() => {
		if (!loading) {
			refreshRegulaciones()
		}
	}, [paginaAct])

	const handleAction = (comunicado, cual) => {
		setRegulacionActual(comunicado, setQueMostrar(cual))
	}

	const subirDocumento = async (archivo) => {
		let fileId = null
		try {
			if (archivo !== null) {
				const serverData = new FormData()
				serverData.append('documento', archivo)

				const { datos: respuesta, msg } = await api.post('a/documentos', serverData)
				fileId = respuesta.id
			}
		} catch (error) {
			toast.error('Error ')
		}

		return fileId
	}

	const nuevaRegulacion = async (data) => {
		const enviar = { ...data }
		if (data.documento) {
			enviar.documentoId = await subirDocumento(data.documento)
		}
		delete enviar.documento

		try {
			const { msg } = await api.post('a/regulaciones-sanitarias', enviar)
			refreshRegulaciones()
			setQueMostrar('')
			toast.success(msg)
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		}
	}

	const editarRegulacion = async (data) => {
		const enviar = { ...data }
		if (data.documento) {
			enviar.documentoId = await subirDocumento(data.documento)
		}
		delete enviar.documento

		try {
			const { msg } = await api.put('a/regulaciones-sanitarias/' + data.id, enviar)
			refreshRegulaciones()
			setQueMostrar('')
			toast.success(msg)
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		}
	}

	const eliminarRegulacion = async (id) => {
		const { msg } = await api.delete('a/regulaciones-sanitarias/' + id)
		refreshRegulaciones()
		setQueMostrar('')
		toast.success(msg)
	}

	useEffect(() => {
		if (!loading) {
			refreshRegulaciones()
		}
	}, [])


	// render
	return (
		<Container fluid id="regulaciones" className="vh-100">
			<Row className="d-flex no-gutters">
				<Col xs={12} className="mt-2">
					<h1>Regulaciones sanitarias</h1>
					<hr />
				</Col>
			</Row>
			<Row className="d-flex no-gutters">
				<Col className="mt-2">
					<Form>
						<Row id="searchbar" className="justify-content-between align-items-center">
							<Col sm={6} md={3} style={{ display: 'block' }}>
								<small>
									<span className="d-none d-sm-inline-block">Mostrar de a</span>
									<Form.Group style={{ display: 'inline-block' }}>
										<Form.Select size="sm" onChange={(e) => setFetchDeACuantos(e.target.value)} className="mx-1">
											{opcionesCuantosMostrar.map((o) => {
												return (
													<option value={o} key={`mostrar-${o}`}>
														{o}
													</option>
												)
											})}
										</Form.Select>
									</Form.Group>
									<span className="ms-2">regulaciones sanitarias</span>
								</small>
							</Col>
							<Col md={5} lg={4}>
								<Form.Group controlId="txtBusqueda">
									<InputGroup>
										<Form.Control
											autoFocus
											value={busqueda}
											onChange={(e) => setBusqueda(e.target.value)}
											type="text"
											placeholder="Buscar"
											aria-label="Buscar"
										/>
										<InputGroup.Text><Form.Label className="mb-0"><i className="fa fa-search"></i></Form.Label></InputGroup.Text>
									</InputGroup>
								</Form.Group>
							</Col>
						</Row>
					</Form>
				</Col>
			</Row>
			<Row className="mb-3">
				<Col>
					<Button variant="primary" onClick={() => setQueMostrar('nueva')} className="mt-2"><i className="fa fa-plus"></i> Nueva</Button>
				</Col>
			</Row>
			{/* Lista regulaciones sanitarias */}
			<Row>
				<Col sm={12} lg={8}>
					{loading ? (
						<Spinner
							animation="border"
							size="lg"
							role="status"
							aria-hidden="true"
							variant="primary"
							className="my-3"
						/>
					) : (
						regulaciones.length === 0 ? (
							<Alert variant="info">No se encontraron regulaciones sanitarias</Alert>
						) : (
							regulaciones.map((regulacion) => {
								const nombreArchivoPartes = regulacion.documento.url.split('/')
								const nombreArchivo = nombreArchivoPartes[nombreArchivoPartes.length - 1]

								const extensionPartes = nombreArchivo.split('.')
								const extension = extensionPartes[extensionPartes.length - 1]

								const isPdf = extension === 'pdf'
								const isDoc = extension === 'docx' || extension === 'doc'

								return (
									<div key={regulacion.id} className={`regulacion border-primary ${regulacion.borrador === '1' ? 'borrador' : ''}`}>
										<div className="img-wrapper">
											<i className={'fa ' + (isDoc ? 'fa-file-word' : (isPdf ? 'fa-file-pdf' : 'fa-file'))}></i>
										</div>
										<div className="data">
											<div className="titulo">{regulacion.titulo}</div>
										</div>
										<div className="fecha">{regulacion.fecha.substr(0, 16)}</div>
										<DropdownButton
											as={ButtonGroup}
											title={<i className="fa fa-ellipsis-v"></i>}
											drop="end"
										>
											<Dropdown.Item eventKey="1" onClick={() => handleAction(regulacion, 'ver')}><i className="fa fa-eye"></i> Ver</Dropdown.Item>
											<Dropdown.Item eventKey="2" onClick={() => handleAction(regulacion, 'editar')}><i className="fa fa-pencil"></i> Editar</Dropdown.Item>
											<Dropdown.Item eventKey="2" onClick={() => handleAction(regulacion, 'eliminar')} variant="danger"><i className="fa fa-trash"></i> Eliminar</Dropdown.Item>
										</DropdownButton>
									</div>
								)
							})
						)
					)}
					<Col>
						<Paginacion
							pagina={paginaAct}
							numPaginas={Math.ceil(numResultados / fetchDeACuantos) || 1}
							setPagina={setPaginaAct}
						/>
					</Col>
				</Col>
				<Col sm={12} lg={4}>
					<h3>Leyenda</h3>
					<div id="regulaciones-leyenda">
						<span className="color borrador border-primary"></span> <span className="texto">Regulaciones sanitarias no publicadas</span>
					</div>
				</Col>
			</Row>

			{/* Panel Nuevo */}
			{queMostrar === 'nueva' && (
				<NuevaRegulacion
					guardar={nuevaRegulacion}
					setQueMostrar={setQueMostrar}
				/>
			)}
			{/* Panel Ver */}
			{regulacionActual && queMostrar === 'ver' &&
				<VerRegulacion
					regulacion={regulacionActual}
					setQueMostrar={setQueMostrar}
				/>
			}
			{/* Panel Editar */}
			{regulacionActual && queMostrar === 'editar' &&
				<EditarRegulacion
					regulacionOriginal={regulacionActual}
					setQueMostrar={setQueMostrar}
					guardar={editarRegulacion}
				/>
			}
			{/* Modal Delete */}
			{
				regulacionActual && queMostrar === 'eliminar' &&
				<EliminarRegulacion
					regulacion={regulacionActual}
					setQueMostrar={setQueMostrar}
					eliminar={eliminarRegulacion}
				/>
			}
		</Container>
	);
}

export default Regulaciones